var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome11X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "122px",
    height: "110px",
    viewBox: "0 0 122 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-home-1@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    transform: "translate(-309.000000, -834.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-column",
    transform: "translate(220.000000, 688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-home-1",
    transform: "translate(89.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    stroke: "#2A5082",
    points: "32.292 33.92 81.678 33.92 81.678 108 32.292 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    stroke: "#2A5082",
    fill: "#E9EAEB",
    fillRule: "nonzero",
    points: "37.99 24.423 75.979 24.423 75.979 33.921 37.99 33.921"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    stroke: "#2A5082",
    fill: "#E9EAEB",
    fillRule: "nonzero",
    points: "53.186 92.805 64.581 92.805 64.581 108 53.186 108"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2A5082",
    points: "41.789 60.514 41.789 51.016 51.287 51.016 51.287 60.514"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2A5082",
    points: "41.789 75.709 41.789 66.211 51.287 66.211 51.287 75.709"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    stroke: "#2A5082",
    points: "13.297 60.514 32.292 60.514 32.292 108 13.297 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    stroke: "#2A5082",
    fill: "#E9EAEB",
    fillRule: "nonzero",
    points: "18.995 51.016 32.292 51.016 32.292 60.514 18.995 60.514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.818,47.217 C70.355,47.217 61.061,56.51 61.061,67.973 C61.061,85.885 78.761,88.307 80.249,106.519 C80.314,107.347 80.984,108 81.817,108 C82.648,108 83.317,107.347 83.381,106.519 C84.87,88.307 102.571,85.885 102.571,67.973 C102.573,56.51 93.278,47.217 81.818,47.217 Z",
    id: "Shape",
    stroke: "#2A5082",
    fill: "#C1F6FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#2A5082",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 81.678,
    cy: 68.112,
    r: 7.598
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.598,
    y1: 108,
    x2: 102.573,
    y2: 108,
    id: "Shape",
    stroke: "#2A5082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.381,11.127 L55.272,11.127 C54.301,9.228 52.014,7.27 49.348,7.27 C48.503,7.27 47.697,7.47 46.957,7.767 C45.471,3.807 41.662,0.836 37.183,0.836 C31.421,0.836 26.749,7.329 26.738,11.128 L11.397,11.128",
    id: "Shape",
    stroke: "#BCC0C4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.894,
    y1: 26.323,
    x2: 7.598,
    y2: 26.323,
    id: "Shape",
    stroke: "#BCC0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.566,20.625 L115.917,20.625 C114.604,16.826 111.877,15.879 108.61,16.275 C107.185,13.82 104.561,12.309 101.516,12.309 C96.996,12.309 93.334,14.927 93.293,20.625 L85.475,20.625",
    id: "Shape",
    stroke: "#BCC0C4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.693,
    y1: 26.323,
    x2: 28.493,
    y2: 26.323,
    id: "Shape",
    stroke: "#BCC0C4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.181,
    y1: 11.127,
    x2: 75.979,
    y2: 11.127,
    id: "Shape",
    stroke: "#BCC0C4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.778,
    y1: 11.127,
    x2: 83.577,
    y2: 11.127,
    id: "Shape",
    stroke: "#BCC0C4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.799,
    y1: 108,
    x2: 0,
    y2: 108,
    id: "Shape",
    stroke: "#2A5082"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.37,
    y1: 108,
    x2: 113.969,
    y2: 108,
    id: "Shape",
    stroke: "#2A5082"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.768,
    y1: 108,
    x2: 121.566,
    y2: 108,
    id: "Shape",
    stroke: "#2A5082"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome11X);
export default __webpack_public_path__ + "static/media/icon-home-1@1x.ed54dd5adb09d9ac7223c1b4c1bf915f.svg";
export { ForwardRef as ReactComponent };